import { createContext, Dispatch, SetStateAction } from 'react'

import type { FilterValue } from 'components/Filter'
import type { CommonFormContextProps } from 'components/Form'
import type { DirtyAdUnitsAttributes } from 'features/inventory/ad-unit/forms/AdUnitTableForm/types'

export type AdUnitListContextType = CommonFormContextProps & {
  dirtyAdUnitsAttributes?: DirtyAdUnitsAttributes
  filters: FilterValue[]
  setDirtyAdUnitsAttributes?: (dirtyAdUnitsAttributes: DirtyAdUnitsAttributes) => void
  setFilters: Dispatch<SetStateAction<FilterValue[]>>
}

export const AdUnitListContext = createContext<AdUnitListContextType>({} as AdUnitListContextType)
